"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Notification Service API
 * This is the API specification for the Notification Service.  The Notification Service is used to send any kind of notification to a contact of Arctic Wolf.  In general, the caller will at most decide who to send the notification to, and the Notification Service will determine how to send it based on that contact\'s preferences. **Note that notifications should NEVER contain any PII or sensitive information.**  All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
 *
 * The version of the OpenAPI document: 0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotificationApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var NotificationApi = /** @class */ (function (_super) {
    __extends(NotificationApi, _super);
    function NotificationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Return the notification stats for IRS
     */
    NotificationApi.prototype.getNotificationIRSStatsV4Raw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v4/stats/irs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.NotificationStatsV4FromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return the notification stats for IRS
     */
    NotificationApi.prototype.getNotificationIRSStatsV4 = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNotificationIRSStatsV4Raw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return the summary of a notification request
     */
    NotificationApi.prototype.getNotificationRequestRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationUUID === null || requestParameters.organizationUUID === undefined) {
                            throw new runtime.RequiredError('organizationUUID', 'Required parameter requestParameters.organizationUUID was null or undefined when calling getNotificationRequest.');
                        }
                        if (requestParameters.requestUUID === null || requestParameters.requestUUID === undefined) {
                            throw new runtime.RequiredError('requestUUID', 'Required parameter requestParameters.requestUUID was null or undefined when calling getNotificationRequest.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationUUID}/notifications/{requestUUID}".replace("{".concat("organizationUUID", "}"), encodeURIComponent(String(requestParameters.organizationUUID))).replace("{".concat("requestUUID", "}"), encodeURIComponent(String(requestParameters.requestUUID))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.NotificationRequestSummaryFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return the summary of a notification request
     */
    NotificationApi.prototype.getNotificationRequest = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNotificationRequestRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Return the supported notification types
     */
    NotificationApi.prototype.getNotificationTypesRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/notification-types",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.NotificationTypesFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Return the supported notification types
     */
    NotificationApi.prototype.getNotificationTypes = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getNotificationTypesRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send a notification to an organization\'s contact via their preferred channel. The caller must provide the notification type and payload. The Notification Service will determine how to send the notification based on the contact\'s preferences.  **Note that notifications should NEVER contain any PII or sensitive information.** All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
     * Send a notification to an organization\'s contact via their preferred channel
     */
    NotificationApi.prototype.sendToOrganizationContactRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationUUID === null || requestParameters.organizationUUID === undefined) {
                            throw new runtime.RequiredError('organizationUUID', 'Required parameter requestParameters.organizationUUID was null or undefined when calling sendToOrganizationContact.');
                        }
                        if (requestParameters.contactUUID === null || requestParameters.contactUUID === undefined) {
                            throw new runtime.RequiredError('contactUUID', 'Required parameter requestParameters.contactUUID was null or undefined when calling sendToOrganizationContact.');
                        }
                        if (requestParameters.sendToOrgContactRequestBody === null || requestParameters.sendToOrgContactRequestBody === undefined) {
                            throw new runtime.RequiredError('sendToOrgContactRequestBody', 'Required parameter requestParameters.sendToOrgContactRequestBody was null or undefined when calling sendToOrganizationContact.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationUUID}/contacts/{contactUUID}/notifications".replace("{".concat("organizationUUID", "}"), encodeURIComponent(String(requestParameters.organizationUUID))).replace("{".concat("contactUUID", "}"), encodeURIComponent(String(requestParameters.contactUUID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SendToOrgContactRequestBodyToJSON)(requestParameters.sendToOrgContactRequestBody),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequestAcceptedResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Send a notification to an organization\'s contact via their preferred channel. The caller must provide the notification type and payload. The Notification Service will determine how to send the notification based on the contact\'s preferences.  **Note that notifications should NEVER contain any PII or sensitive information.** All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
     * Send a notification to an organization\'s contact via their preferred channel
     */
    NotificationApi.prototype.sendToOrganizationContact = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendToOrganizationContactRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Send a notification to an organization\'s contacts via their preferred channels.  The caller must provide the notification type, payload, and recipients.  The Notification Service will determine how to send the notification based on the contact\'s preferences.  **Note that notifications should NEVER contain any PII or sensitive information.**  All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
     * Send a notification to an organization\'s contacts via their preferred channels
     */
    NotificationApi.prototype.sendToOrganizationContactsRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.organizationUUID === null || requestParameters.organizationUUID === undefined) {
                            throw new runtime.RequiredError('organizationUUID', 'Required parameter requestParameters.organizationUUID was null or undefined when calling sendToOrganizationContacts.');
                        }
                        if (requestParameters.sendToOrgContactsInput === null || requestParameters.sendToOrgContactsInput === undefined) {
                            throw new runtime.RequiredError('sendToOrgContactsInput', 'Required parameter requestParameters.sendToOrgContactsInput was null or undefined when calling sendToOrganizationContacts.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("BearerAuth", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/api/v1/organizations/{organizationUUID}/notifications".replace("{".concat("organizationUUID", "}"), encodeURIComponent(String(requestParameters.organizationUUID))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.SendToOrgContactsInputToJSON)(requestParameters.sendToOrgContactsInput),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.RequestAcceptedResponseFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Send a notification to an organization\'s contacts via their preferred channels.  The caller must provide the notification type, payload, and recipients.  The Notification Service will determine how to send the notification based on the contact\'s preferences.  **Note that notifications should NEVER contain any PII or sensitive information.**  All notifications should be of a Data Sensitivity Level of 3 or less.  For more information, see [Data Sensitivity Levels](https://arcticwolf.atlassian.net/wiki/spaces/PD/pages/3770155054/Data+Sensitivity+Levels+-+Data+Mapping).
     * Send a notification to an organization\'s contacts via their preferred channels
     */
    NotificationApi.prototype.sendToOrganizationContacts = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.sendToOrganizationContactsRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return NotificationApi;
}(runtime.BaseAPI));
exports.NotificationApi = NotificationApi;
